export const addCandidateConstants = {
  // create candidate Kit
  CREATE_CANDIDATE_PROFILE_RECRUITER_ACTION_REQUEST:
    "CREATE_CANDIDATE_PROFILE_RECRUITER_ACTION_REQUEST",
  CREATE_CANDIDATE_PROFILE_RECRUITER_ACTION_SUCCESS:
    "CREATE_CANDIDATE_PROFILE_RECRUITER_ACTION_SUCCESS",
  CREATE_CANDIDATE_PROFILE_RECRUITER_ACTION_FAILURE:
    "CREATE_CANDIDATE_PROFILE_RECRUITER_ACTION_FAILURE",

  // update candidate Kit
  UPDATE_CANDIDATE_PROFILE_RECRUITER_ACTION_REQUEST:
    "UPDATE_CANDIDATE_PROFILE_RECRUITER_ACTION_REQUEST",
  UPDATE_CANDIDATE_PROFILE_RECRUITER_ACTION_SUCCESS:
    "UPDATE_CANDIDATE_PROFILE_RECRUITER_ACTION_SUCCESS",
  UPDATE_CANDIDATE_PROFILE_RECRUITER_ACTION_FAILURE:
    "UPDATE_CANDIDATE_PROFILE_RECRUITER_ACTION_FAILURE",

  ADD_CANDIDATE_SKILL_RECRUITER_ACTION_REQUEST:
    "ADD_CANDIDATE_SKILL_RECRUITER_ACTION_REQUEST",
  ADD_CANDIDATE_SKILL_RECRUITER_ACTION_SUCCESS:
    "ADD_CANDIDATE_SKILL_RECRUITER_ACTION_SUCCESS",
  ADD_CANDIDATE_SKILL_RECRUITER_ACTION_FAILURE:
    "ADD_CANDIDATE_SKILL_RECRUITER_ACTION_FAILURE",
};
